// extracted by mini-css-extract-plugin
export default {"switch":"styles_switch__4ldfT","slider":"styles_slider__TV2WY","round":"styles_round__NRQih"};